export default {
    toggleButton: "freecash.toggle.button"
}